.bonus_section {
  border-radius: 5px;
  background: #F8EEBF;
  padding: 12px 0;
  position: relative;
  overflow: visible;
  margin: 10px 0;

  label {
    display: flex;
    gap: 5px;
    align-content: center;
    align-items: center;
    cursor: pointer;

    .bonus {
      background-color: #000;
      color: #fff;
      padding: 8px 21px 8px 13px;
      font-family: var(--font-family, 'sofia-pro, sans-serif');
      font-size: 12px;
      font-style: normal;
      font-weight: 900;
      line-height: normal;
      position: relative;
      @media (max-width: 767px) {
        padding: 8px 18px 8px 4px;
      }
    }

    .bonus::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-top: 17px solid transparent;
      border-bottom: 17px solid transparent;
      border-right: 17px solid #F8EEBF;
    }



    input {
      display: inline-block;
      width: 28px;
      height: 28px;
      border-radius: 3px;
      border: 2px solid #999;
      background: var(--White, #FFF);
      position: relative;
      cursor: pointer;
    }

    input[type=checkbox]::before, input[type=radio]::before {
      content: "✓";
      opacity: 0;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 28px;
      height: 28px;
      position: absolute;
      top: -2px;
      left: -2px;
      border-radius: 10%;
      transform: scale(1);
      font-size: 20px;
      font-weight: bold;
      box-shadow: none;
      background-color: transparent;
    }

    input[type=checkbox]:hover::before,
    input[type=radio]:hover::before {
      opacity: 0.5;
      color: #ccc;
      background-color: transparent;
    }

    input[type=checkbox]:checked::before, input[type=radio]:checked::before {
      transform: scale(1);
      opacity: 1;
      box-shadow: inset 28px 28px #00B902;
      color: #fff !important;
    }

    .title {
      color: var(--Black, #000);
      font-family: var(--font-family, 'sofia-pro, sans-serif');

      font-size: 16px;
      letter-spacing: -0.32px;
      font-style: normal;
      font-weight: 400;
      margin-left: 10px;
      line-height: 1em;

      @media (max-width: 767px) {
        font-size: 10px;
        font-weight: 400;
        letter-spacing: -0.2px;

      }

      strong {
        text-transform: uppercase;
        color: var(--Black, #000);
        font-family: var(--font-family, 'sofia-pro, sans-serif');
        display: block;
        font-weight: 900;
      }
    }

    .bonus_img {
      position: absolute;
      top: -10px;
      right: 15px;
    }
    @media (max-width: 767px) {
      .bonus_img {
        right: -18px;
      }
    }
    .bonus_img:after {
      content: "FREE";
      color: #fff;
      font-family: var(--font-family, 'sofia-pro, sans-serif');
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      position: absolute;
      top: 50%;
      right: -12px;
      width: 48px;
      height: 48px;
      margin-top: -24px;
      display: flex;
      align-content: center;
      justify-content: center;
      align-items: center;
      @media (max-width: 767px) {
        right: 4px;
      }
    }
    .bonus_img span:after {
      content: "$39.99";
      color: #fff;
      font-family: var(--font-family, 'sofia-pro, sans-serif');
      font-size: 9px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      position: absolute;
      top: 50%;
      text-decoration: line-through;
      right: -12px;
      width: 48px;
      height: 10px;
      margin-top: -14px;
      display: flex;
      align-content: center;
      justify-content: center;
      align-items: center;
      @media (max-width: 767px) {
        right: 4px;
      }
    }
    .bonus_img:before {
      animation: rotate 5s linear infinite;
      content: "";
      background: url("https://www.seatcoversolutions.com/cdn/shop/t/7/assets/circle-red.svg") no-repeat 0 0;
      position: absolute;
      top: 50%;
      right: -12px;
      width: 48px;
      height: 48px;
      margin-top: -24px;
      @media (max-width: 767px) {
        right: 4px;
      }
    }


  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(1turn)
  }
}